import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import dayjs from 'dayjs';

import { VennueAccessRequestItem } from '../../../graphql/API';
import BaseDialog, { BaseDialogProps } from '../Base';

type Props = {
  onConfirm?: () => void;
  accessRequest?: VennueAccessRequestItem | null;
} & BaseDialogProps;

export const OldRequestWarningDialog: React.FC<Props> = ({
  onConfirm,
  accessRequest,
  ...restProps
}) => {
  const createdAt = accessRequest?.createdAt;
  const ageLabel = createdAt ? dayjs(createdAt).fromNow(true) : '';

  return (
    <BaseDialog
      width='440px'
      height='unset'
      minHeight='unset'
      titleComponent={<></>}
      {...restProps}
    >
      <Box py={1}>
        <Typography fontSize={'18px'} fontFamily={'Poppins'} fontWeight={500} mb={1}>
          This request is over {ageLabel} old.
        </Typography>
        <Typography fontSize={'15px'} fontFamily={'Poppins'} color='#555' mb={1.5}>
          The member’s shipping details, availability, or campaign interest may have changed since
          the request was submitted.
        </Typography>
        <Typography fontSize={'15px'} fontFamily={'Poppins'} color='#555'>
          Do you still want to accept it?
        </Typography>

        <Box display={'flex'} gap={2} mt={3}>
          <Button
            variant='text'
            color='primary'
            sx={{ fontWeight: 500, fontSize: '15px' }}
            onClick={() => {
              restProps?.onClose?.({}, 'backdropClick');
            }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            sx={{ fontWeight: 500, fontSize: '15px', py: 1.5, textTransform: 'capitalize' }}
            fullWidth
            onClick={() => {
              if (onConfirm) onConfirm();
              restProps?.onClose?.({}, 'backdropClick');
            }}
          >
            Accept anyway
          </Button>
        </Box>
      </Box>
    </BaseDialog>
  );
};
